import React from 'react'
import { Link } from 'react-router-dom'
import gplay from "../../Assets/new-assets/gplay.png"
import appstore from "../../Assets/new-assets/appstore.png"
import logo from "../../Assets/new-assets/mp-logo.svg"
import { useNavigate } from 'react-router-dom'
import { androidLink, iosLink } from '../../Redux/Actions/config'
const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className='footer'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-5'>
              <div className='ftr-logo-col ftr-border'>
                  <img src={logo} />
                  <p>A KidEx Venture Private Limited company</p>
                <div onClick={() => window.location.href = androidLink}>
  <img src={gplay} alt="Google Play Store" className='mb-3'/>
</div>
<div onClick={() => window.location.href = iosLink}>
  <img src={appstore} alt="Apple App Store" />
</div>

              </div>
          </div>
          <div className='col-lg-4 order-1 order-lg-0'>
              <ul className='navbar-nav ftr-link pt-4 pt-md-0  mt-4 mt-md-0 pe-lg-0'>
                <li className="nav-item"><a className="nav-link"  href='#'>About </a></li>
                {/* <li className="nav-item"><a className="nav-link" href='#'>Career</a></li> */}
                <li className="nav-item"><a className="nav-link" href='#'>Contact</a></li>
                <li className="nav-item"><a className="nav-link" href='/tnc'>Terms</a></li>
                <li className="nav-item"><a className="nav-link" href='/ppc'>Privacy</a></li>
              </ul>
          </div>
          <div className='col-lg-3 newsletter  pe-2 pe-md-0'>
            <h2>Subscribe to our Newsletter</h2>
            <div class="d-flex flex-column pe-5 pe-md-0">
                <input type="text" class="form-control w-100 mb-2" placeholder="Email" aria-label="First name" />
                {/* <button className='default-btn text-white border-white bg-white default-color py-3'>Contact MasterNaukri Team</button> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer